import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import api, { GenericError } from "../api"
import { CreateWarehouseRequest, UpdateWarehouseRequest, WarehouseModel } from "../api/warehouse.api"

export interface WarehousesListState {
    warehouses: WarehouseModel[]
    loading: boolean
    //TODO: make error interface
    error?: GenericError
    success?: boolean
    selectedWarehouse?: number
}

const initialState: WarehousesListState = {
    warehouses: [],
    loading: false
}

export const loadWarehouses = createAsyncThunk("warehouses/list", async (thunkAPI) => {
    try {
        const response = await api.warehouse.warehousesList()

        return response
    } catch (error: any) {
        console.log(error)
    }
})

export const createWarehouse = createAsyncThunk(
    "warehouses/create",
    async (newWarehouseData: CreateWarehouseRequest, thunkAPI) => {
        try {
            const response = await api.warehouse.createWarehouse(newWarehouseData)

            return response
        } catch (error: any) {
            console.log(error)
            return thunkAPI.rejectWithValue(error)
        }
    }
)

export const updateWarehouse = createAsyncThunk(
    "warehouses/update",
    async (existingWarehouseData: UpdateWarehouseRequest, thunkAPI) => {
        try {
            const response = await api.warehouse.updateWarehouse(existingWarehouseData)

            return response
        } catch (error: any) {
            console.log(error)
            return thunkAPI.rejectWithValue(error)
        }
    }
)

export const deleteWarehouse = createAsyncThunk("warehouses/delete", async (warehouseId: number, thunkAPI) => {
    try {
        const response = await api.warehouse.deleteWarehouse(warehouseId)

        return response
    } catch (error: any) {
        console.log(error)
        return thunkAPI.rejectWithValue(error)
    }
})

export const warehousesSlice = createSlice({
    name: "warehouses",
    initialState,

    reducers: {
        clearError: (state: WarehousesListState) => {
            state.error = undefined
        },
        resetSuccess: (state: WarehousesListState) => {
            state.success = undefined
        },
        setWarehouse: (state: WarehousesListState, action: PayloadAction<any>) => {
            state.selectedWarehouse = action.payload
        }
    },

    extraReducers: {
        [loadWarehouses.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadWarehouses.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.response?.data?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.data?.payload }
            } else if (action.payload?.response?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.payload }
            } else if (action.payload?.response?.data?.data?.error) {
                state.error = { error: action.payload?.response?.data?.data?.error }
            } else {
                state.error = { error: action.payload?.response?.data?.error }
            }
        },
        [loadWarehouses.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.warehouses = action.payload?.data?.data?.payload || []
        },

        [createWarehouse.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [createWarehouse.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.response?.data?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.data?.payload }
            } else if (action.payload?.response?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.payload }
            } else if (action.payload?.response?.data?.data?.error) {
                state.error = { error: action.payload?.response?.data?.data?.error }
            } else {
                state.error = { error: action.payload?.response?.data?.error }
            }
        },
        [createWarehouse.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.success = true
            // state.warehouses = action.payload.data.payload.data
        },

        [updateWarehouse.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [updateWarehouse.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.response?.data?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.data?.payload }
            } else if (action.payload?.response?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.payload }
            } else if (action.payload?.response?.data?.data?.error) {
                state.error = { error: action.payload?.response?.data?.data?.error }
            } else {
                state.error = { error: action.payload?.response?.data?.error }
            }
        },
        [updateWarehouse.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.success = true
            // state.warehouses = action.payload.data.payload.data
        },
        [createWarehouse.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.success = true
            // state.warehouses = action.payload.data.payload.data
        },

        [deleteWarehouse.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [deleteWarehouse.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.response?.data?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.data?.payload }
            } else if (action.payload?.response?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.payload }
            } else if (action.payload?.response?.data?.data?.error) {
                state.error = { error: action.payload?.response?.data?.data?.error }
            } else {
                state.error = { error: action.payload?.response?.data?.error }
            }
        },
        [deleteWarehouse.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.success = true
            // state.warehouses = action.payload.data.payload.data
        }
    }
})

export const { clearError, resetSuccess, setWarehouse } = warehousesSlice.actions

export default warehousesSlice.reducer
